module.exports = __webpack_public_path__ + "static/media/DanskeHuman-MediumItalic.f8a5173e.woff";